import CuratedChip from './CuratedChip';

export default CuratedChip;
